@for (size of sizes; track $index) {
<mat-checkbox
  [checked]="value.includes(size)"
  (click)="onCheckChanged($event,size)"
  [disabled]="disabled"
  >{{size}}</mat-checkbox
>
}
